$('input[type="number"]').on('keydown', function (e) {
    var value = String.fromCharCode(e.keyCode);

    if( value === 'E' )
    {
        e.preventDefault();
    }
});

window.loadReport = function (reportUrl, shouldReload = true, tabName = 'Feedback Report')
{
    window.open(reportUrl, tabName);

    if( shouldReload )
    {
        location.reload();
    }
};

window.checkAllBoxesByClass = function(className, trigger)
{
    let checked = false;
    if( trigger.checked )
    {
        checked = true;
    }

    $(className).prop('checked',checked).change();
};

window.showUserResetPasswordModal = function (url, userId, programId, alternateEmailsURL) {
    function setModalData(data) {
        $('#resetPasswordForm input[name=user_id]').val(userId);
        if (programId) {
            $('#resetPasswordForm input[name=program_id]').val(programId);
        }
        $('#resetPasswordModal .accountName').html(data.name);
        $('#resetPasswordModal .accountEmail').html(data.email);

        $('#resetPasswordModal').modal('show');
    }

    $.ajax({url: url, method: 'GET'})
        .done(function (response) {
            let data = response.data

            if (alternateEmailsURL) {
                // Get alternate emails
                $.getJSON(alternateEmailsURL)
                    .done(function (alternateData) {
                        if (alternateData.length > 0) {
                            // Delete program_id hidden field
                            $('#resetPasswordForm input[name=program_id]').remove();

                            // Selector for field
                            const $alternateEmails = $('#resetPasswordForm #alternateEmails');

                            // Add select for getting program_id
                            $alternateEmails.html(`
                                This user has alternate emails available. Select a program to send password reset email to the corresponding alternate email instead. <br />
                                <select name="program_id" class="form-control" style="max-width: 100%;">
                                    <option value="">None</option>
                                    ${alternateData.map(function(program) { return `<option value="${program['id']}">${program['name']} - ${program['alt_email']}</option>` })}
                                </select>
                            `);

                            // Show field
                            $alternateEmails.show();
                        }

                        setModalData(data);
                    });
            } else {
                setModalData(data);
            }
        });
};

window.showUserBulkResetPasswordModal = function showBulkUserResetPasswordModal(email) {


    $('#resetPasswordForm input[name=user_id]').val(userId);
    if (programId) {
        $('#resetPasswordForm input[name=program_id]').val(programId);
    }
    $('#resetPasswordModal .accountName').html(data.name);
    $('#resetPasswordModal .accountEmail').html(email);

    $("#resetPasswordModal").modal("show");

};

window.showSuspendedAccountModal = function( url, userId )
{
    $.ajax({
        url: url,
        method: "GET",
    })
        .done(function (response) {
            let data = response.data;

            $("#suspendedModal").modal("show");
            $('#suspendedForm input[name=email]').val( data.email );
            $('#suspendedForm input[name=user_id]').val( userId );
            $('#suspendedModal .accountName').html( data.name  );
            $('#suspendedModal .accountEmail').html( data.email );
        });
};

window.showUnsuspendParticipantModal = function( url, userId )
{
    $.ajax({
        url: url,
        method: "GET",
    })
        .done(function (response) {
            let data = response.data;

            $('#unsuspend_participant_modal .name').html( data.name  );
            $('#unsuspend_participant_modal .email').html( data.email );

            $("#unsuspend_participant_modal").modal("show");
            $('#activate_participant_btn').attr('data-user-id', userId);
        });
};

window.showEmailModal = function( url )
{
    $.ajax({
        url: url,
        method: "GET",
    })
        .done(function (response) {
            let data = response.data;
            $("#emailModal").modal("show");
            $('#emailForm input[name=email]').val(data.email);
            $('#emailModal #modal_title').html('Email ' + data.name);
        });
};

window.showBulkEmailModal = function(className, title)
{
    let selectedEmails = [];
    if($(className + ':checked').length)
    {
        $(className + ':checked').each(function() {
            let email = $(this).data( "email" );

            if(typeof email !== "undefined")
            selectedEmails.push(email);                        
        });
        $('#emailForm input[name=email]').val(selectedEmails);
        $("#emailModal #modal_title").html(title);
        $('#required_email_text').css('display', 'none');
        $("#emailModal").modal("show");
    }
    else
    {
        $("#must_select_users_modal").modal('show');
    }
};

window.showEmailAllModal = function(emails, title)
{
  let selectedEmails = [];
  if(emails.length > 0)
  {
    $(emails).each(function() {
      if(typeof this !== undefined)
      {
        selectedEmails.push(this);
      }
    });
    $('#emailForm input[name=email]').val(selectedEmails);
    $("#emailModal #modal_title").html(title);
    $("#emailModal").modal("show");
  }
}

window.showDeleteModal = function(resourceType, resourceName, deleteFnc )
{
    $("#delete_modal #resource_type").html(resourceType);
    $("#delete_modal #resource_name").html(resourceName);
    $("#delete_modal #delete_btn").attr('onclick', deleteFnc);
    $("#delete_modal").modal('show');
};

window.resetPricingTierForm = function( url )
{
    $('#pricing_tier_edit_form #name').val();
    $('#pricing_tier_edit_form #description').val();

    location.href = url;
};

window.resetCertificaitonTypeForm = function(url)
{
    $('#certification_type_edit_form #name').val();
    $('#certification_type_edit_form #description').val();
    $('#certification_type_edit_form input[type=checkbox]').attr('checked',false);

    location.href = url;
};

window.deleteCertificationType = function(requestUrl, redirectUrl)
{
	let request = $.ajax({
		url: requestUrl,
		method: 'DELETE'
	});

	// Callback handler that will be called on success
	request.done(function (response, textStatus, jqXHR)
	{
		console.log(response);
		if(response.status) {
			location.href = redirectUrl;
		} else {
			$('#delete_resource_ajax_error_msg').html(response.message);
			$('#delete_resource_ajax_error').removeClass('d-none');
		}
	});

	// Callback handler that will be called on failure
	request.fail(function (jqXHR, textStatus, errorThrown)
	{
		// Log the error to the console
		console.error("The following error occurred: " + textStatus, errorThrown);
		$('#delete_resource_ajax_error_msg').html(textStatus);
		$('#delete_resource_ajax_error').removeClass('d-none');
	});
};

window.deleteDiscountCode = function(requestUrl, redirectUrl)
{
	let request = $.ajax({
        url: requestUrl,
        method: "DELETE"
    });

    // Callback handler that will be called on success
    request.done(function (response, textStatus, jqXHR) {
        location.href = redirectUrl;
    });

    // Callback handler that will be called on failure
    request.fail(function (jqXHR, textStatus, errorThrown) {
        // Log the error to the console
        console.error("The following error occurred: " + textStatus, errorThrown);
    });

};

window.randomPassword = function(length) {
	let chars = "abcdefghijklmnopqrstuvwxyz!@#$%^&*()-+<>ABCDEFGHIJKLMNOP1234567890";
	let pass = "";
	for (let x = 0; x < length; x++) {
		let i = Math.floor(Math.random() * chars.length);
		pass += chars.charAt(i);
    }
    return pass;
}

window.readURL = function(input) {
    if (input.files && input.files[0]) {
        let reader = new FileReader();

        reader.onload = function (e) {
            $('#image_url').attr('src', e.target.result);
        }

        reader.readAsDataURL(input.files[0]);
    }
}

window.getStates = function(url, countyInputId = 'country', stateInputId = 'state', selectedValue = null, callbackFunction = null)
{
    let country = $(`#${countyInputId}`).val();

    if( country == 'all' || country == '')
    {
        let state = $(`#${stateInputId}`);
        state.empty().append('<option value="">Select</option>');
        return false;
    }
    url = url.replace('countryCode',country);
    $.ajax({
        type: 'GET',
        url: url,
        success: function( response )
        {
            if( response.status )
            {
                let state = $(`#${stateInputId}`);
                let options = response.data;
                let optionHtml = '';

                state.empty();

                $.each(options, function( key, value ){
                    optionHtml += "<option value='" + value.isoCode + "'" + (value.isoCode === selectedValue ? 'selected' : '') + ">" + value.name + "</option>";
                });

                if(options.length === 0){
                    let countryName = $(`#${countyInputId} option:selected`).text();
                    optionHtml += "<option value='" + country + "'" + 'selected' + ">" + countryName + "</option>";
                }

                state.html(optionHtml);

                callbackFunction && callbackFunction();
            }
            else
            {
                //console.log('ERROR: ' + response.message);
            }
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
            // Log the error to the console
            // console.error("The following error occurred: " + textStatus, errorThrown);
        }
    });
};

window.validateEmail = function( formName = null, url )
{
    let email = $("#email").val();

    if( email.length == 0 )
    {
        return true;
    }

    $.ajax({
        type: 'POST',
        url: url,
        data: {email: email},
        success: function( response )
        {
            if( response.status )
            {
                if( response.data.is_available )
                {
                    $("#email_validated").val("true");
                    if( response.data.show_message )
                    {
                        $("#email_valid").addClass('text-success').removeClass('text-danger').text("Email is available.");
                    }
                    $("#emailValid").parent().addClass('d-none');
                    $("#emailValid").html('');

                    if( formName !== null && formName.length > 0 )
                    {
                        $(formName).submit();
                    }
                    
                }
                else
                {
                    $("#email_valid").addClass('text-danger').removeClass('text-success').text("Email is not available.");
                    $("#email").val('').focus();
                    $("#emailValid").html('Email is not available.');
                    $("#emailValid").parent().removeClass('d-none');
                }
            }
            else
            {
                $("#emailValid").html(response.message);
                $("#emailValid").parent().removeClass('d-none');
            }
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
            // Log the error to the console
						console.error("The following error occurred: " + textStatus, errorThrown);
						$("#emailValid").html(textStatus);
						$("#emailValid").parent().removeClass('d-none');
        }
    });


}

$('#generate_password').click(function() {
    let password = randomPassword(10);

    $('#password').attr('type', 'text');
    $('#password').val(password);
    $('#confirm_password').val(password);
});


$("#change_image").change(function(){
    readURL(this);
});

/***************************************************************
 *
 * End New Code
 *
 **************************************************************/

/***************************************************************
 *
 * Start of Javascript that is the equivalent of an aborted fetus
 *
 **************************************************************/

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

window.DATE_FORMAT = 'YYYY-MM-DD';
window.DATE_TIME_FORMAT = 'YYYY-MM-DD hh:mm A';
window.EMP_ASSESSMENT_ID = 3;

$.clearInput = function () {
    $( 'form:not("#product_edit_form, #purchase-form")' ).trigger("reset");
    $( "form:not('#product_edit_form, #purchase-form') input[type=hidden]:not('[name=_token]')" ).val( "" );

    $("#program_view_section input[name='program_id']").val($("#program_view_section").attr("data-program-id"));
    $("#program_view_section #program_id").val($("#program_view_section").attr("data-program-id"));
};

var $form   = $(".form-manage"),
    $inputs = $form.find( "input, select, button, textarea" );

$(document).on('hidden.bs.modal','.modal', function () {
    $.clearInput();
});

$( "#distributor" ).on("change", function () {
    if ( $(this).val() ) {
        $( "#practitioner" ).removeAttr( "readonly" );
    }
    else {
         $( "#practitioner" ).attr( "readonly", true );
    }
});

$('#doResetPassword').on('click', function () {
    const $form = $("#resetPasswordForm");
    const $inputs = $form.find("input, select, button, textarea");

    // Disabled form elements will not be serialized.
    $inputs.prop("disabled", true);

    const url = $(this).attr('data-route');
    const redirect_url = $(this).attr('data-redirect');

    const method = 'POST';

    const userId = $('#resetPasswordForm input[name=user_id]').val();
    let programId = $('#resetPasswordForm input[name=program_id]').val();

    // If program selector is in the form, use it instead to get program id.
    const $programSelector = $('#resetPasswordForm select[name=program_id]');
    if ($programSelector.length !== 0) {
        programId = $programSelector.val();
    }

    if (programId === '') {
        programId = null;
    }

    const request = $.ajax({
        url: url,
        method: method,
        data: {user_id: userId, program_id: programId}
    });

    // Callback handler that will be called on success
    request.done(function (response, textStatus, jqXHR) {
        if (response) {
            location.reload();
        } else {
            $('#resetPasswordModal').modal('hide');
            $('#successMessage').html(' Password reset email has been sent');
            $('.alert-success').show().delay(5000).fadeOut('slow');
        }
    });

    // Callback handler that will be called on failure
    request.fail(function (jqXHR, textStatus, errorThrown) {
        // Log the error to the console
        console.error("The following error occurred: " + textStatus, errorThrown);
    });

    // Callback handler that will be called regardless
    // if the request failed or succeeded
    request.always(function () {
        // Re-enable the inputs
        $inputs.prop("disabled", false);
    });
});

$('#suspendedForm #doSuspendAccount').on('click', function () {

	let $form = $("#suspendedForm");

	let $inputs = $form.find("input, button, textarea");

	let serializedData = $form.serialize();

	// Disabled form elements will not be serialized.
	$inputs.prop("disabled", true);
    var url = $(this).attr('data-route');
    var redirectUrl = $(this).attr('data-redirect-route');
	$.ajax({
		url: url,
		method: "POST",
		data: serializedData,
      success: function( response )
      {
          location.href = redirectUrl;
      },
      error: function(jqXHR, textStatus, errorThrown) {
			// Log the error to the console
			console.error("The following error occurred: " + textStatus, errorThrown);
		},
      complete: function(){
			$inputs.prop("disabled", false);
      }
	});
});

window.selectedCheckboxes = [];

$('#chkSelectAll').click(function(event){
    window.selectedCheckboxes = [];
    event.stopPropagation();

     if(this.checked)
     {
        // Iterate each checkbox
        $(':checkbox').each(function() {

            this.checked = true;
            let rowId = $(this).attr( "data-administrator-id" );
            let email = $("#row_"+rowId+" td:nth-child(4) a").html();

            if(typeof email !== "undefined")
            selectedCheckboxes.push(email);                        
        });

    } 
    else 
    {
        $(':checkbox').each(function() {
            this.checked = false;                       
        });
    }
    $('#emailForm input[name=email]').val(selectedCheckboxes);
});

window.doCheckUncheck = function (elem)
{
    let rowId = $(elem).attr( "data-administrator-id" );
    let email = $("#row_"+rowId+" td:nth-child(4) a").html();

    if(elem.checked) {
        if (!selectedCheckboxes.indexOf(email) > -1) {
            selectedCheckboxes.push(email);
        }                               
    } else {
        selectedCheckboxes.splice($.inArray(email, selectedCheckboxes),1);
    }
    $('#emailForm input[name=email]').val(selectedCheckboxes);
};

window.doSendEmail = function (route) {
    $('#errorMessageContainer').addClass('d-none');

	let $form = $("#emailForm");

	let $inputs = $form.find("input, button, textarea");

	let serializedData = $form.serialize();
    var url = route;
	// Disabled form elements will not be serialized.
	$inputs.prop("disabled", true);

	$.ajax({
		url: url,
		type: "POST",
		data: serializedData,
		success: function(response)
		{
			$('#emailModal').modal('hide');

			if( response.status ) {
				$('#successMessage').html('Email has been sent');
				$('.alert-success').show().delay(5000).fadeOut('slow');
			} else {
				$('#errorMessage').html(response.message);
				$('#errorMessageContainer').removeClass('d-none');
			}
			$inputs.removeAttr("disabled");
		},
		error: function(jqXHR, textStatus, errorThrown)
		{
			// Log the error to the console
			$('#emailModal').modal('hide');
			$('#errorMessage').html(textStatus);
			$('#errorMessageContainer').removeClass('d-none');

			console.error("The following error occurred: " + textStatus, errorThrown);
			$inputs.removeAttr("disabled");
		}
	});
}

$('#doSendEmail').on('click', function () {

	$('#errorMessageContainer').addClass('d-none');

	let $form = $("#emailForm");

	let $inputs = $form.find("input, button, textarea");

	let serializedData = $form.serialize();
    var url = $(this).attr('data-route');
	// Disabled form elements will not be serialized.
	$inputs.prop("disabled", true);

	$.ajax({
		url: url,
		type: "POST",
		data: serializedData,
		success: function(response)
		{
			$('#emailModal').modal('hide');

			if( response.status ) {
				$('#successMessage').html('Email has been sent');
				$('.alert-success').show().delay(5000).fadeOut('slow');
			} else {
				$('#errorMessage').html(response.message);
				$('#errorMessageContainer').removeClass('d-none');
			}
			$inputs.removeAttr("disabled");
		},
		error: function(jqXHR, textStatus, errorThrown)
		{
			// Log the error to the console
			$('#emailModal').modal('hide');
			$('#errorMessage').html(textStatus);
			$('#errorMessageContainer').removeClass('d-none');

			console.error("The following error occurred: " + textStatus, errorThrown);
			$inputs.removeAttr("disabled");
		}
	});

});

$( "#add_distributor_form #first_name, #add_distributor_form #last_name" ).on( "keyup", function () {       
    if ( $('#first_name').val() && $('#last_name').val())
    {
        $( "#add_distributor_form #poc_name" ).val($('#first_name').val()+' ' +$('#last_name').val());
    }
    else if ( $('#first_name').val() )
    {
        $( "#add_distributor_form #poc_name" ).val($('#first_name').val());
    }
    else if ( $('#last_name').val() )
    {
        $( "#add_distributor_form #poc_name" ).val($('#last_name').val());
    }    
});

$( "#add_distributor_form #email" ).on( "keyup", function () {
    if ( $('#email').val() )
    {
        $( "#add_distributor_form #poc_email" ).val($('#email').val());
    }
});

window.deleteInvalidDiscountCodes = function(url, cartRequestUrl)
{
    $.ajax({
        url: url,
        method: 'DELETE',
    })
        .done(function (response) {
            updateCartTotals(cartRequestUrl);
        });
};

window.updateCartTotals = function ( url )
{
    let ajaxData = {};

		let billingState = $('#billing_state').val();
		let shippingCity = $('#shipping_city').val();
		let shippingZip = $('#shipping_postal_code').val();
		let shippingCountry = $('#shipping_country').val();

    if( billingState ) {
        ajaxData.billing_state = billingState;
		}
		
		if( shippingCity ) {
			ajaxData.shipping_city = shippingCity;
		}

		if( shippingZip ) {
			ajaxData.shipping_postal_code = shippingZip;
		}

		if( shippingCountry ) {
			ajaxData.shipping_country = shippingCountry;
		}

    $.ajax({
        url: url,
        method: 'GET',
        data: ajaxData
    })
        .done(function (response) {
            let totals = response.data.totals;

            let subTotal = totals.subtotal,
                shipping = totals.shipping,
                handling = totals.handling,
                processing = totals.processing,
                totalTax = totals.tax,
                discount = totals.discount,
                total    = totals.total;

            $("#checkout_subtotal").html(subTotal);
            // $("#checkout_shipping").html(shipping);
            $(".checkout_shipping").html(shipping);
            $("#checkout_handling").html(handling);
            $("#checkout_processing").html(processing);
            $("#checkout_taxes").html(totalTax);
            $("#discount").html(discount);
            $("#cart_total").html(total);
            $("#total").html(total);
        });
};

$( "#practitioner_form #first_name, #practitioner_form #last_name" ).on( "keyup", function () {
    if ( $('#first_name').val() && $('#last_name').val())
    {
        $( "#practitioner_form #organization_name" ).val($('#practitioner_form #first_name').val()+' ' +$('#practitioner_form #last_name').val());
    }
    else if ( $('#first_name').val() )
    {
        $( "#practitioner_form #organization_name" ).val($('#practitioner_form #first_name').val());
    }
    else if ( $('#last_name').val() )
    {
        $( "#practitioner_form #organization_name" ).val($('#practitioner_form #last_name').val());
    }    
});

$( "#organization_name" ).on("keydown", function () {
    let keyword = $(this).val();
    $( "#organization_id" ).val('');
    var url = $(this).attr('data-route');
    $.ajax({
		 url: url,
       type: "GET",
       data: { keyword: keyword },
       success: function(response)
		 {
			 let availableTags = [];

			 $.map(response.data, function (val, i) {
				 availableTags.push( { label: val.name + ' - ' + val.code, value: val.id } )
			 });

			 $( "#organization_name" ).autocomplete({
				 source: availableTags,
				 appendTo: "#organizationWrapper",
				 select: function(event, ui) {
					 $( "#organization_name" ).val(ui.item.label);
					 $( "#organization_id" ).val(ui.item.value);
					 return false; // Prevent the widget from inserting the value.
				 },
				 focus: function(event, ui) {
					 $("#organization_name").val(ui.item.label);
					 return false; // Prevent the widget from inserting the value.
				 }
			 });
		 },
		 error: function(jqXHR, textStatus, errorThrown)
		 {
			 // Log the error to the console
			 console.error("The following error occurred: " + textStatus, errorThrown);
		 }
    });
});

$( ".master_trainer_name" ).on("blur", function () {
    var elementId = this.id;
    if (Number($( "#master_trainer_id_" + elementId ).val()) == 0 )
    {
        $(this).val('');
    }
});

// $( ".master_trainer_name" ).on("keydown", function () {
//     var elementId = this.id;
//     var url = $(this).attr('data-route');
//     let keyword = $(this).val();
//     if( keyword.length > 0 )
// 	{
//         $( "#master_trainer_id_" + elementId ).val('');

//         $.ajax({
//             url: url,
//             type: "GET",
//             data: { keyword: keyword },
//             success: function(response)
//             {
//                 let availableTags = [];

//                 $.map(response.data, function (val, i) {
//                     availableTags.push( { label: val.first_name + ' ' + val.last_name, value: val.id } )
//                 });

//                 $( '#' + elementId ).autocomplete({
//                     source: availableTags,
//                     appendTo: "#masterTrainerWrapper" + elementId,
//                     focus: function(event, ui) {
//                         $(this).val(ui.item.label);
//                         return false;
//                     },
//                     select: function (event, ui) {
//                         $(this).val(ui.item.label); 
//                         $( "#master_trainer_id_" + elementId ).val(ui.item.value);
//                         return false;
//                     }
//                 });
//             },
//             error: function(jqXHR, textStatus, errorThrown)
//             {
//                 // console.error("The following error occurred: " + textStatus, errorThrown);
//             }
//         });
//     }
// });

$( "#practitioner_referrer_name" ).on("blur", function () {
    if ( Number( $( "#practitioner_referrer_id").val() ) == 0 )
    {
        $(this).val('');
    }
});

// $( "#practitioner_referrer_name" ).on("keydown", function () {
//     var url = $(this).attr('data-route');
//     let keyword = $(this).val();
//     if( keyword.length > 0 )
// 	{
//         $( "#practitioner_referrer_id" ).val('');

//         $.ajax({
//             url: url,
//             type: "GET",
//             data: { keyword: keyword },
//             success: function(response)
//             {
//                 let availableTags = [];

//                 $.map(response.data, function (val, i) {
//                     availableTags.push( { label: val.first_name + ' ' + val.last_name, value: val.id } )
//                 });

//                 $( '#practitioner_referrer_name' ).autocomplete({
//                     source: availableTags,
//                     appendTo: "#practiionerReferrerWrapper",
//                     focus: function(event, ui) {
//                         $( "#practitioner_referrer_name" ).val(ui.item.label);
//                         return false;
//                     },
//                     select: function (event, ui) {
//                         $( "#practitioner_referrer_name" ).val(ui.item.label); 
//                         $( "#practitioner_referrer_id" ).val(ui.item.value);
//                         return false;
//                     }
//                 });
//             },
//             error: function(jqXHR, textStatus, errorThrown)
//             {
//                 // console.error("The following error occurred: " + textStatus, errorThrown);
//             }
//         });
//     }
// });

$(document).ready(function() {
    $('[data-toggle="popover"]').popover();
});

window.enhanceDropdownAccessibility = function(dropdownToggle, dropdownMenu) {
    const dropdownItems = dropdownMenu.querySelectorAll('.dropdown-item');

    dropdownToggle.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.click();
        } else if (event.key === 'Tab' && dropdownMenu.classList.contains('show')) {
            event.preventDefault();
            dropdownItems[0].focus();
        }
    });

    dropdownToggle.addEventListener('click', function () {
        if (dropdownMenu.classList.contains('show')) {
            dropdownItems[0].focus();
        }
    });

    dropdownItems.forEach((item, index) => {
        item.addEventListener('keydown', function (event) {
            if (event.key === 'ArrowDown' || (event.key === 'Tab' && !event.shiftKey)) {
                event.preventDefault();
                const nextItem = dropdownItems[index + 1] || dropdownItems[0];
                nextItem.focus();
            } else if (event.key === 'ArrowUp' || (event.key === 'Tab' && event.shiftKey)) {
                event.preventDefault();
                const prevItem = dropdownItems[index - 1] || dropdownItems[dropdownItems.length - 1];
                prevItem.focus();
            } else if (event.key === 'Escape') {
                dropdownToggle.click();
                dropdownToggle.focus();
            }
        });
    });
}